import { companyInfo, navItems, services } from '@/mocks/home';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="px-4 md:px-10 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <span className="w-10 h-10 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-stack-line text-xl"></i>
              </span>
              <span className="font-heading font-semibold text-base text-background-50">
                {companyInfo.shortName}
              </span>
            </div>
            <p className="text-sm text-background-300 leading-relaxed">
              {companyInfo.name}，专注建筑建材、机械电气、金属材料、电子配件等物资供应，为企业与工程客户提供可靠、高效的一站式采购支持。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm text-background-50 mb-4 tracking-wide">网站导航</h4>
            <ul className="flex flex-col gap-2.5">
              {navItems.map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    className="text-sm text-background-300 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm text-background-50 mb-4 tracking-wide">主营产品</h4>
            <ul className="flex flex-col gap-2.5">
              {services.map((s) => (
                <li key={s.title}>
                  <a
                    href="#services"
                    className="text-sm text-background-300 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {s.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm text-background-50 mb-4 tracking-wide">联系我们</h4>
            <ul className="flex flex-col gap-3 text-sm text-background-300">
              <li className="flex items-start gap-2">
                <i className="ri-phone-line text-accent-400 mt-0.5"></i>
                <a href={`tel:${companyInfo.phone}`} className="hover:text-accent-400 transition-colors cursor-pointer">
                  {companyInfo.phone}
                </a>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-mail-line text-accent-400 mt-0.5"></i>
                <a href={`mailto:${companyInfo.email}`} className="hover:text-accent-400 transition-colors cursor-pointer">
                  {companyInfo.email}
                </a>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-accent-400 mt-0.5"></i>
                <span>{companyInfo.address}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-primary-800/60 px-4 md:px-10 py-5">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-400">
          <p>© {year} {companyInfo.name} 版权所有</p>
          <a
            href="https://beian.miit.gov.cn/"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="hover:text-accent-400 transition-colors cursor-pointer"
          >
            {companyInfo.icp}
          </a>
        </div>
      </div>
    </footer>
  );
}